import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface ExternalApplicationState {
    loanId?: string | null;
    accessLink?: string | null;
    redirectLink?: string | null;
}

function useExternalApplicationData(
    initialState: ExternalApplicationState = {
        loanId: undefined,
        accessLink: undefined,
        redirectLink: undefined,
    },
) {
    const [externalApplicationData, setExternalApplicationData] =
        useState<ExternalApplicationState>(initialState);

    return { externalApplicationData, setExternalApplicationData };
}

export const ExternalApplicationStore = createStore(useExternalApplicationData);

export type ExternalApplicationStore = ReturnType<typeof useExternalApplicationData>;
